<template>
  <div class="card-wrap">
    <div class="content-title">数据总览</div>
    <ul class="card-list" v-loading="loading">
      <li class="card-item">
        <div class="item-cell left-cell">
          <div class="item-title">曝光</div>
          <span class="item-num">{{ convertDataPreview.showNum }}</span>
          <div class="item-des">
            环比
            <span v-if="convertDataPreview.showIncreRate >= 0" class="up"
              >+{{ convertDataPreview.showIncreRate }}%<i class="el-icon-caret-top"></i
            ></span>
            <span v-else>{{ convertDataPreview.showIncreRate }}%<i class="el-icon-caret-bottom"></i></span>
          </div>
        </div>
        <div class="item-cell">
          <div class="item-title">点击</div>
          <span class="item-num">{{ convertDataPreview.clickNum }}</span>
          <div class="item-des">
            环比
            <span v-if="convertDataPreview.clickIncreRate >= 0" class="up"
              >+{{ convertDataPreview.clickIncreRate }}%<i class="el-icon-caret-top"></i
            ></span>
            <span v-else>{{ convertDataPreview.clickIncreRate }}%<i class="el-icon-caret-bottom"></i></span>
          </div>
        </div>
      </li>
      <li class="card-item">
        <div class="item-cell left-cell">
          <div class="item-title">自然激活</div>
          <span class="item-num">{{ convertDataPreview.organicNum }}</span>
          <div class="item-des">
            环比
            <span v-if="convertDataPreview.organicIncreRate >= 0" class="up"
              >+{{ convertDataPreview.organicIncreRate }}%<i class="el-icon-caret-top"></i
            ></span>
            <span v-else>{{ convertDataPreview.organicIncreRate }}%<i class="el-icon-caret-bottom"></i></span>
          </div>
        </div>
        <div class="item-cell">
          <div class="item-title">非自然激活</div>
          <span class="item-num">{{ convertDataPreview.activeNum }}</span>
          <div class="item-des">
            环比
            <span v-if="convertDataPreview.activeIncreRate >= 0" class="up"
              >+{{ convertDataPreview.activeIncreRate }}%<i class="el-icon-caret-top"></i
            ></span>
            <span v-else>{{ convertDataPreview.activeIncreRate }}%<i class="el-icon-caret-bottom"></i></span>
          </div>
        </div>
      </li>
      <li class="card-item">
        <div class="item-cell left-cell">
          <div class="item-title">转化率</div>
          <span class="item-num">{{ convertDataPreview.convertRate }}%</span>
          <div class="item-des">
            环比
            <span v-if="convertDataPreview.covertIncreRate >= 0" class="up"
              >+{{ convertDataPreview.covertIncreRate }}%<i class="el-icon-caret-top"></i
            ></span>
            <span v-else>{{ convertDataPreview.covertIncreRate }}%<i class="el-icon-caret-bottom"></i></span>
          </div>
        </div>
        <div class="item-cell">
          <div class="item-title rmb">成本</div>
          <span class="item-num">{{ convertDataPreview.cost }}</span>
          <div class="item-des">
            环比
            <span v-if="convertDataPreview.costIncreRate >= 0" class="up"
              >+{{ convertDataPreview.costIncreRate }}%<i class="el-icon-caret-top"></i
            ></span>
            <span v-else>{{ convertDataPreview.costIncreRate }}%<i class="el-icon-caret-bottom"></i></span>
          </div>
        </div>
      </li>
      <li class="card-item">
        <div class="item-cell left-cell">
          <div class="item-title rmb">自然收入</div>
          <span class="item-num">{{ convertDataPreview.organicIncome }}</span>
          <div class="item-des">
            环比
            <span v-if="convertDataPreview.organicIncomeRate >= 0" class="up"
              >+{{ convertDataPreview.organicIncomeRate }}%<i class="el-icon-caret-top"></i
            ></span>
            <span v-else>{{ convertDataPreview.organicIncomeRate }}%<i class="el-icon-caret-bottom"></i></span>
          </div>
        </div>
        <div class="item-cell">
          <div class="item-title rmb">非自然收入</div>
          <span class="item-num">{{ convertDataPreview.nonOrganicIncome }}</span>
          <div class="item-des">
            环比
            <span v-if="convertDataPreview.nonOrganicIncomeRate >= 0" class="up"
              >+{{ convertDataPreview.nonOrganicIncomeRate }}%<i class="el-icon-caret-top"></i
            ></span>
            <span v-else>{{ convertDataPreview.nonOrganicIncomeRate }}%<i class="el-icon-caret-bottom"></i></span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { transFilterData } from "./config";
import { getCalculateChainData } from "@/api/tools";
export default {
  name: "CardList",
  props: {
    filterData: {
      type: Object,
    },
  },
  data() {
    return {
      convertDataPreview: {},
      loading: false,
    };
  },
  watch: {},
  methods: {
    searchData(data) {
      //维度相关
      const { pkg, platType, advertiserId, campaignId, campaignName, dateEnd, dateStart } = transFilterData(data);
      this.loading = true;
      getCalculateChainData({
        pkg,
        platType,
        advertiserId,
        campaignId,
        campaignName,
        dateEnd,
        dateStart,
      })
        .then((res) => {
          this.loading = false;
          if (res.code === "0000") {
            this.convertDataPreview = res.data;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.card-wrap {
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  padding: 16px 24px;
  margin-bottom: 16px;
  .content-title {
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
    font-size: 15px;
    margin-bottom: 16px;
  }
  .card-list {
    padding: 0px;
    margin: 0px;
    list-style: none;
    display: flex;
    .card-item {
      width: 320px;
      height: 120px;
      border-radius: 6px;
      background: rgba(230, 243, 255, 1);
      margin-right: 32px;
      .item-cell {
        display: inline-block;
        width: 50%;
        padding: 12px 16px;
        box-sizing: border-box;
        position: relative;
        &.left-cell::after {
          content: "";
          display: inline-block;
          position: absolute;
          right: 6px;
          top: 33px;
          width: 0px;
          height: 45px;
          border-left: 1px solid rgba(0, 0, 0, 0.15);
        }
        .item-title {
          color: rgba(0, 0, 0, 0.95);
          font-weight: bold;
          font-size: 15px;
          margin-bottom: 14px;
          &.rmb:after {
            content: "￥";
            color: rgba(0, 0, 0, 0.45);
            font-size: 13px;
            margin-left: 2px;
          }
        }
        .item-num {
          color: rgba(24, 144, 255, 1);
          font-weight: bold;
          font-size: 20px;
          display: inline-block;
          margin-bottom: 14px;
        }
        .item-des {
          color: rgba(0, 0, 0, 0.45);
          font-size: 13px;
          .up {
            margin-left: 5px;
            color: rgba(30, 194, 57, 1);
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
